import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { marcarTratadoControlePragaDoenca } from '../service';

import {
  MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA,
  MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_PENDING,
  MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_SUCCESS,
  MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_FAILURE,
  NEW_FILTER_CONTROLE_PRAGA_DOENCA,
} from '../actionTypes';

import { AlertError, AlertSuccess } from '@components/common/AlertToast';

function* sagaMarcarTratadoControlePragaDoenca(action) {
  yield put({ type: MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_PENDING, id: action.id });

  try {
    yield call(marcarTratadoControlePragaDoenca, action.id);

    yield put({ type: MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_SUCCESS, id: action.id });

    AlertSuccess('Controle marcado como tratado com sucesso!');

    // Recarrega a listagem para atualizar o status
    yield put({ type: NEW_FILTER_CONTROLE_PRAGA_DOENCA });

  } catch (error) {
    console.log(error);
    yield put({ type: MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_FAILURE });
    AlertError('Falha ao marcar como tratado! Tente novamente...');
  }
}

export default function* watchMarcarTratadoControlePragaDoenca() {
  yield takeLatest(MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA, sagaMarcarTratadoControlePragaDoenca);
}
